/**
 * Phase 14 — central toggle for local-mode (`@wt-codegraph/local` web bundle).
 *
 * When `localMode` is true the web UI:
 *   - issues same-origin requests (no `apiBaseUrl` host),
 *   - skips MSAL initialisation entirely,
 *   - returns a stub bearer token (`local-mode`) the local HTTP server ignores.
 */
import { ENV } from './env.js';

export const LOCAL_MODE: boolean = ENV.localMode;

/** Stub token used by the local-mode `ApiClient`. Server-side is no-auth. */
export function localModeToken(): Promise<string> {
  return Promise.resolve('local-mode');
}
